<template>
  <input/>
</template>

<script>
  let vm = {
    name: 'input-data-picker',
    props: {
      value: {
        validator: function (val) {
          return val === null || val instanceof Date || typeof val === 'string'
        }
      },
      format: {
        default: 'dd/mm/yy'
      },
      onBlur: Function
    },
    watch: {
      value (value) {
        this.setValue(value)
      },
      openDate () {
        this.setPageDate()
      },
      initialView () {
        this.setInitialView()
      }
    },
    methods: {
      setValue (date) {
        $(this.$el).val(date)
      }
    },
    mounted () {
      var vmm = this
      $(this.$el).datepicker({
        closeText: 'Fechar',
        prevText: '&#x3c;Anterior',
        nextText: 'Pr&oacute;ximo&#x3e;',
        currentText: 'Hoje',
        monthNames: ['Janeiro', 'Fevereiro', 'Mar&ccedil;o', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        dayNames: ['Domingo', 'Segunda-feira', 'Ter&ccedil;a-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sabado'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        weekHeader: 'Sm',
        dateFormat: 'dd/mm/yy',
        firstDay: 0,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: '',
        onSelect: function (date) {
          vmm.$emit('input', date)
        }
      })
      $(this.$el).val(this.value)
      $(this.$el).on('change', function () {
        vmm.$emit('input', this.value)
      })
    }
  }
  module.exports = vm
</script>
}


// WEBPACK FOOTER //
// src/components/spark-components/spark-scrollbar/SparkInputDataPicker.vue